export default "__VITE_ASSET__BF2vVCT2__"